module.exports = __webpack_public_path__ + "static/media/IndentUpload.7af85a4f.csv";